import { Expose } from 'class-transformer';
import { Model } from './model';

export class MeasurementUnit extends Model {

  @Expose()
  code: string;
}
